import { useMutation } from 'react-query';

import { hiringGraphicRoute } from '@features/boostMyJobs/api/constants';
import axiosInstance from '@server/axiosInstance';

export const useRequestHiringGraphic = () => {
  const {
    mutate: requestHiringGraphic,
    isLoading: isRequestHiringGraphicLoading,
  } = useMutation({
    mutationFn: () =>
      axiosInstance.post(hiringGraphicRoute).then((res) => res.data),
  });

  return {
    requestHiringGraphic,
    isRequestHiringGraphicLoading,
  };
};
